// extracted by mini-css-extract-plugin
export default {"confirmContainer":"ConfirmContent_confirmContainer__9ArIb","title":"ConfirmContent_title__9E9mf"};